import { render, staticRenderFns } from "./Add-News-Events.vue?vue&type=template&id=58322a44&scoped=true"
import script from "./Add-News-Events.vue?vue&type=script&lang=js"
export * from "./Add-News-Events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58322a44",
  null
  
)

export default component.exports